import React from 'react';
import { Tag, useMediaQueryContext } from '@fourthwall/components';
export const ThemeStatus = ({ isActive }) => {
    const media = useMediaQueryContext();
    return (React.createElement(Tag, { label: isActive ? 'Live theme' : 'Inactive theme', appearance: isActive ? 'success' : 'neutral', size: media.laptop ? 'large' : 'small' }));
};
